import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/web/driver/debt/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 处理欠款单
export function handleDebt(data) {
  return request.send({
    url: `/pmy/sys/web/driver/debt/handle`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 总览统计信息
export function getOverview(data) {
  return request.send({
    url: `/pmy/sys/web/driver/debt/overview`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 详情
export function detailInfo(driverDebtId) {
  return request.send({
    url: `/pmy/sys/web/driver/debt/detail?driverDebtId=${driverDebtId}`,
    method: "get",
  });
}
